import { toZonedTime } from 'date-fns-tz';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';

import { parseDateInput } from './parseDateInput';

type OptionsType = {
  timezone?: string;
  format?: string;
};
/**
 * Парсит входное значение в дату и переводит её из UTC
 * в указанную временную зону.
 *
 * Поддерживает те же форматы, что и {@link parseDateInput}:
 * @example
 * parseParseDateInputInTz(1710000000, "Europe/Moscow");
 * parseParseDateInputInTz("2024-03-01T12:00:00Z", "UTC");
 */
export function parseParseDateInputInTz(
  input: unknown,
  { timezone = DEFAULT_TIMEZONE, format }: OptionsType = {},
): Date | null {
  const date = parseDateInput(input, { format });
  return date ? toZonedTime(date, timezone) : null;
}
